import PlaceholderScreen from '../../components/PlaceholderScreen/PlaceholderScreen'

export default function PortfolioScreen() {
  return <PlaceholderScreen title="Portfolio Data" />
}